import request from '@/plugin/axios'


export function discountApplyDetails(discountApplyId) {
  return request({
    url: '/api/discountApplyDetailByApplyId/' + discountApplyId,
    method: 'get'
  })
}


export function searchDiscountApplyDetailById(id) {
  return request({
    url: '/api/searchDiscountApplyDetailById/' + id,
    method: 'get'
  })
}
export function doApproveDiscountApplyDetail(data) {
  return request({
    url: '/api/discount_approve',
    method: 'post',
    data: data
  })
}